module.exports = __webpack_public_path__ + "img/f-1-4.10e2cf8.png";